import React from 'react';
import Routes from './Routes';
import 'react-toastify/dist/ReactToastify.css';
import './assets/scss/theme.scss';
import { SnackbarProvider } from 'notistack';
import { LoadingProvider } from './Pages/Utility/spinner/LoadingContext';
import GlobalSpinner from './Pages/Utility/spinner/GlobalSpinner';

function App() {
  return (
    <React.Fragment>
      <LoadingProvider>
        <SnackbarProvider
          autoHideDuration={2000}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <GlobalSpinner />
          <Routes />
        </SnackbarProvider>
      </LoadingProvider>
    </React.Fragment>
  );
}

export default App;